export default __webpack_public_path__ + "static/media/roadmap-music.6e7d6662.mp3";